import * as cons from './constants';
import * as apis from './apis';
import { requestActionMaker } from '../helper';

export const getCourseCategoriesForSelection = para => requestActionMaker({ cons: cons.GET_COURSE_CATEGORIES_FOR_SELECTION, api: apis.getAllCourseCategory, ...para });
